// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__93GU4","left":"styles_left__zTRwU"};